import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { src: Search },
    border: "rectangle",
    cssOverrides: {
        formField: css`
            min-width: 350px;
            button {
                background-color: #d1d3d4;
            }
        `,
    },
};
searchInputStyles.autocompleteWrapper = {
    css: css`
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        max-width: 100%;
    `,
};
